const FinancingControl = () => import(/* webpackChunkName: "financingControl" */ './FinancingControl.vue')
const FormFinancing = () => import(/* webpackChunkName: "formFinancing" */ './FormFinancing.vue')

const index = {
  path: 'financing/control',
  name: 'Financing Control',
  component: FinancingControl,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const create = {
  path: 'financing/create',
  name: 'Create Financing',
  component: FormFinancing,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const edit = {
  path: 'financing/edit/:idFinanciamento',
  name: 'Edit Financing',
  component: FormFinancing,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index,
  create,
  edit
}
